export default "__VITE_ASSET__DKCD331f__"